/* lls-lp.js — PLANTILLA landing_page: comportamiento de la capa de código.
   Marquee + cinta (loop sin salto), sticky show-on-scroll, selector de ofertas
   y disparador de Releasit por HOOK (ver TEMPLATE.md §5 — el botón se busca
   DENTRO del trigger, nunca por el id global #rsi_buy_now_button, que está
   duplicado en la página y devuelve el del carrito lateral).
   Cero manipulación de estilos .rsi-* (RULES.md 11). */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* duplica el contenido de un track para que translateX(-50%) sea un loop
     perfecto; ajusta la duración según el ancho para velocidad pareja. */
  function loopTrack(track, secPer100) {
    if (!track || reduced || track.getAttribute('data-lp-loop')) return;
    var kids = Array.prototype.slice.call(track.children);
    if (!kids.length) return;
    kids.forEach(function (n) { var c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
    var w = track.scrollWidth / 2;
    var dur = Math.max(18, Math.round((w / 100) * (secPer100 || 3.2)));
    track.style.setProperty('--dur', dur + 's');
    track.setAttribute('data-lp-loop', '1');
  }

  ready(function () {
    /* ---- Reloj de urgencia (barra superior + tarjeta de cierre) ----
       Todos los relojes que comparten `data-clave` marcan EXACTAMENTE lo
       mismo: el fin se calcula una vez por clave y se reparte. Dos relojes de
       la misma oferta con tiempos distintos se desmienten entre si.

       Dos modos:
       - fecha: instante fijo. Si ya paso, el reloj se OCULTA en vez de quedarse
         en ceros, que es peor que no tener reloj.
       - evergreen: cada visitante estrena su cuenta y se guarda en
         localStorage, asi que al recargar no vuelve a empezar. Cuando se
         agota, arranca un ciclo nuevo. Sin localStorage (modo privado, o
         bloqueado) cae a una cuenta en memoria: sigue funcionando.  */
    var finPorClave = {};
    function finDeReloj(nodo) {
      var clave = nodo.getAttribute('data-clave') || 'lp';
      if (finPorClave[clave] != null) return finPorClave[clave];
      var fin = null;
      if (nodo.getAttribute('data-modo') === 'fecha') {
        var crudo = (nodo.getAttribute('data-fecha') || '').trim().replace(' ', 'T');
        var t = crudo ? Date.parse(crudo) : NaN;
        if (!isNaN(t)) fin = t;
      }
      if (fin == null) {
        var horas = parseFloat(nodo.getAttribute('data-horas')) || 72;
        var llave = 'lp-cd-' + clave;
        var ahora = Date.now();
        var guardado = null;
        try { guardado = parseInt(window.localStorage.getItem(llave), 10); } catch (e) { guardado = null; }
        /* Una cuenta guardada MAS LARGA que la duracion actual se descarta
           (2026-10-09): al pasar la faja de CO de 4 horas a 5 minutos, quien ya
           habia entrado seguia viendo su cuenta vieja de horas. */
        if (!guardado || isNaN(guardado) || guardado <= ahora || guardado - ahora > horas * 3600000 + 1000) {
          guardado = ahora + horas * 3600000;
          try { window.localStorage.setItem(llave, String(guardado)); } catch (e) {}
        }
        fin = guardado;
      }
      finPorClave[clave] = fin;
      return fin;
    }

    var relojes = Array.prototype.slice.call(document.querySelectorAll('[data-lp-cd]'));
    if (relojes.length) {
      /* Cada digito vive en su propia casilla y se anima SOLO cuando cambia
         (misma animacion que la referencia: escala 1 -> 1.1 -> 1 en 0.3s).
         Repintar los seis digitos cada segundo haria parpadear a los tres que
         no cambiaron, y el bloque entero temblaria una vez por segundo.

         Sin dias: las horas se acumulan (3 dias = 72 h). Por eso la duracion
         se limita a 96 h en el schema, que es lo que cabe en dos digitos; si
         una fecha fija dejara mas, se muestra 99 y sigue bajando. */
      var pintarUnidad = function (grupo, valor) {
        var texto = (valor < 10 ? '0' : '') + valor;
        var casillas = grupo.querySelectorAll('.d');
        for (var i = 0; i < casillas.length; i++) {
          var ch = texto.charAt(i);
          if (casillas[i].textContent === ch) continue;
          casillas[i].textContent = ch;
          (function (celda) {
            celda.classList.remove('flip');
            /* forzar reflow: sin esto el navegador agrupa quitar y poner la
               clase en el mismo frame y la animacion no vuelve a arrancar. */
            void celda.offsetWidth;
            celda.classList.add('flip');
          })(casillas[i]);
        }
      };
      var pintar = function () {
        var ahora = Date.now();
        relojes.forEach(function (nodo) {
          var resta = finDeReloj(nodo) - ahora;
          if (resta <= 0) {
            if (nodo.getAttribute('data-modo') === 'fecha') { nodo.classList.add('fin'); return; }
            /* evergreen: arranca un ciclo nuevo EN EL SITIO (2026-10-09). Antes
               se quedaba en 00:00:00 hasta recargar, y con cuentas cortas (la
               faja de CO usa 5 minutos) eso era lo normal, no la excepcion. */
            var claveFin = nodo.getAttribute('data-clave') || 'lp';
            delete finPorClave[claveFin];
            try { window.localStorage.removeItem('lp-cd-' + claveFin); } catch (e) {}
            resta = Math.max(0, finDeReloj(nodo) - ahora);
          }
          var seg = Math.floor(resta / 1000);
          var valores = { h: Math.min(99, Math.floor(seg / 3600)), m: Math.floor((seg % 3600) / 60), s: seg % 60 };
          Array.prototype.slice.call(nodo.querySelectorAll('.g')).forEach(function (g) {
            pintarUnidad(g, valores[g.getAttribute('data-u')]);
          });
        });
      };
      pintar();
      setInterval(pintar, 1000);
    }

    /* marquee de confianza */
    document.querySelectorAll('.lls-lp-marquee .track').forEach(function (t) { loopTrack(t, 2.6); });
    /* cinta de testimonios */
    document.querySelectorAll('.lls-lp-cinta .track').forEach(function (t) { loopTrack(t, 3.6); });

    /* sticky: aparece cuando el usuario pasa el hero (~1ª pantalla) */
    var sticky = document.querySelector('.lls-lp-sticky');
    if (sticky) {
      var onScroll = function () {
        if (window.scrollY > (window.innerHeight * 0.7)) sticky.classList.add('show');
        else sticky.classList.remove('show');
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---- Releasit: disparador (MISMO patrón que las páginas de producto) ----
       Verificado en vivo 2026-07-21 sobre veldrop.co:
       - Releasit REEMPLAZA el <a href="/rsi-btn-hook"> del hook por su propio
         <button id="rsi_buy_now_button"> DENTRO de .lls-lp-hook. Ese botón abre,
         cierra y REABRE el formulario sin límite (probado en Guau Vital).
       - En la página conviven VARIOS #rsi_buy_now_button (id duplicado): el del
         carrito lateral (#CartDrawer) y el del app block. Un querySelector
         global agarra el del carrito -> abre el form del CARRITO y no reabre.
         Por eso NUNCA se busca por id global: se busca DENTRO del contenedor.
       - Cero manipulación del carrito a mano: Releasit lo reinicia él mismo
         (su CartService). Si lo vaciamos en paralelo, su flujo se rompe. */
    var hook = document.querySelector('.lls-lp-hook') || document.querySelector('.releasit-trigger');
    var appb = document.querySelector('.releasit-appblock');
    function botonReleasit() {
      return (hook && hook.querySelector('button'))
        || (appb && appb.querySelector('#rsi-button-hook button'))
        || (appb && appb.querySelector('button'));
    }
    /* ---- CAUSA DEL "DOBLE CLIC" Y SU ARREGLO (2026-09-10) ----------------
       Medido en vivo: el <button> de Releasit se monta dentro del hook casi
       enseguida, pero nace DESHABILITADO y solo se habilita ~1,4 s despues,
       cuando su app termina cart-init -> auto-add-to-cart -> quantity-offer-init
       (el bundle lo pinta con disabled mientras loadingState.loadingReason
       esta en esa lista). El codigo anterior solo comprobaba que el boton
       EXISTIERA: hacia preventDefault (matando el ancla) y luego .click()
       sobre un control deshabilitado, que por especificacion HTML no dispara
       NADA. De ahi el silencio del primer clic y el segundo que si abre.
       Ahora se espera a que el boton este UTILIZABLE y se le da al cliente
       una senal desde el primer clic. Cero estilos .rsi-*: solo se toca el
       rotulo de NUESTRO boton. */
    var ETIQUETA_ABRIENDO = 'Abriendo\u2026';
    var abriendo = false;
    function botonUsable() {
      var b = botonReleasit();
      return (b && !b.disabled) ? b : null;
    }
    function formAbierto() {
      var i = document.querySelector('input[name="phone"]');
      if (!i) return false;
      var r = i.getBoundingClientRect();
      return r.width > 0 && r.height > 0;
    }
    function marcarOcupado(el) {
      if (!el || !el.classList || !el.classList.contains('js-releasit')) return;
      if (el.getAttribute('data-lp-rotulo') === null) el.setAttribute('data-lp-rotulo', el.innerHTML);
      el.innerHTML = ETIQUETA_ABRIENDO;
      el.setAttribute('aria-busy', 'true');
      el.style.opacity = '0.72';
      el.style.pointerEvents = 'none';
    }
    function soltar() {
      abriendo = false;
      Array.prototype.slice.call(document.querySelectorAll('.js-releasit[aria-busy="true"]')).forEach(function (el) {
        var r = el.getAttribute('data-lp-rotulo');
        if (r !== null) el.innerHTML = r;
        el.removeAttribute('aria-busy');
        el.style.opacity = '';
        el.style.pointerEvents = '';
      });
    }
    function vigilarForm(t0) {
      var iv = setInterval(function () {
        if (formAbierto() || Date.now() - t0 > 8000) { clearInterval(iv); soltar(); }
      }, 120);
    }
    function abrir(el) {
      if (abriendo) return true;
      abriendo = true;
      marcarOcupado(el);
      var t0 = Date.now();
      var listo = botonUsable();
      if (listo) { listo.click(); vigilarForm(t0); return true; }
      /* El boton existe pero sigue deshabilitado (o aun no monta):
         esperamos a que se pueda usar en vez de perder el clic. */
      var esperar = setInterval(function () {
        var b = botonUsable();
        if (b) { clearInterval(esperar); b.click(); vigilarForm(t0); }
        else if (Date.now() - t0 > 8000) { clearInterval(esperar); soltar(); }
      }, 60);
      return true;
    }
    /* CTAs, sticky y opciones de cantidad: todos abren el formulario.
       Si Releasit aún no montó su botón, se respeta el enlace del elemento
       (ancla #oferta) en vez de dejar un clic muerto. */
    document.querySelectorAll('.js-releasit').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        abrir(el);
      });
    });
    /* Selección tipo radio de la opción de oferta + apertura del formulario.
       La deselección se acota al GRUPO (.<pfx>-lp-sel), no a toda la página:
       la landing lleva dos ofertas, y con un querySelectorAll global elegir un
       pack arriba borraba la marca del de abajo, así que el cliente se
       encontraba la segunda oferta sin nada seleccionado. */
    Array.prototype.slice.call(document.querySelectorAll('.lls-lp-sel')).forEach(function (grupo) {
      var opts = Array.prototype.slice.call(grupo.querySelectorAll('.lls-lp-opt'));
      opts.forEach(function (o) {
        o.addEventListener('click', function () {
          opts.forEach(function (x) { x.classList.remove('sel'); });
          o.classList.add('sel');
          abrir();
        });
      });
    });

    /* ---- Acordeón FAQ (portado de reloj_presidencial_premium/rp-script.js) ----
       Un solo item abierto a la vez; alto animado con max-height (necesita
       JS porque el contenido es de longitud variable). */
    document.querySelectorAll('.lls-lp-faq .faq-item').forEach(function (item) {
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = item.classList.contains('is-open');
        document.querySelectorAll('.lls-lp-faq .faq-item.is-open').forEach(function (other) {
          other.classList.remove('is-open');
          other.querySelector('.faq-q').setAttribute('aria-expanded', 'false');
          other.querySelector('.faq-a').style.maxHeight = '0px';
        });
        if (!open) {
          item.classList.add('is-open');
          q.setAttribute('aria-expanded', 'true');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
    var faqT = null;
    window.addEventListener('resize', function () {
      clearTimeout(faqT);
      faqT = setTimeout(function () {
        document.querySelectorAll('.lls-lp-faq .faq-item.is-open .faq-a').forEach(function (a) { a.style.maxHeight = a.scrollHeight + 'px'; });
      }, 150);
    });
  });
})();
